// extracted by mini-css-extract-plugin
export var textBlockWithImage = "text-block-with-image-module--text-block-with-image--1YKIn";
export var text = "text-block-with-image-module--text--1g4LG";
export var title = "text-block-with-image-module--title--2GUK7";
export var subtitle = "text-block-with-image-module--subtitle--1BvBx";
export var image = "text-block-with-image-module--image---Y_7s";